import { Dom7 as $ } from "framework7/bundle";
import { readItem } from "./storage.js";

/** .min-fillscreen auf die Resthoehe der Seite strecken. */
export function adjustScreen() {
    $(".page.fullscreen").each(function () {
        const page = $(this);
        const fill = page.find(".min-fillscreen");
        if (fill.length === 0) return;

        const view = $(fill.data("page-view"));
        const winHeight = view.outerHeight(true);
        let height = 0;

        view.children().each(function () {
            if (!$(this).hasClass("min-fillscreen")) height += $(this).outerHeight(false);
        });

        const subtract = fill.data("page-substractHeight");
        if (subtract) height += $(subtract).height();

        if (winHeight - height > 0) fill.css("min-height", winHeight - height + "px");
    });
}

/** Skin-Klasse aus dem Profil auf <body> setzen. */
export function setTheme() {
    const themeClass = readItem("theme_class", "localStorage");
    $("body").attr("class", "");
    if (themeClass !== "") $("body").addClass(themeClass);
}

/** Alle .eq-height-elem eines .eq-height-wrapper auf die groesste Hoehe bringen. */
export function setHeight() {
    $(".eq-height-wrapper").each(function () {
        let maxHeight = 50;
        $(this).find(".eq-height-elem").each(function () {
            if ($(this).height() > maxHeight) maxHeight = $(this).height();
        });
        $(this).find(".eq-height-elem").css("height", maxHeight + "px");
    });
}

export function isEmail(email) {
    return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);
}

/** Gespeichertes Ergebnis eines Elements aus der Ergebnisliste. */
export function getSavedResult(resObj, objectId, objType) {
    if (objType !== "text") return undefined;
    const hit = (resObj || []).find((r) => r.object_id === objectId);
    return hit ? hit.result : "";
}

/**
 * Bereits gespeicherte Antworten (results aus chapter/list) im DOM eintragen
 * und die betroffenen Bloecke sperren.
 *
 * object_id der Results entspricht dem, was die App beim Speichern schickt:
 *  - Radio/Checkbox/Multitag: id der Option (= Element-id)
 *  - Text/Textarea:           contentData.id (= Element-id), result = Text
 *  - Likert (segmented):      contentData.id (= data-name), value = 1..5
 *  - Reminder:                `${id}-1-${tag}` bzw. `${id}-2-${zeit}` (= data-name)
 *
 * Wird nach dem ersten $update aufgerufen; nachfolgende $update-Aufrufe
 * lassen DOM-seitige Klassen/Properties unangetastet (gleicher Mechanismus
 * wie bei den toggle-Buttons).
 */
export function applySavedResults(results, root) {
    const scope = root || document;
    let touched = [];

    (results || []).forEach((r) => {
        const id = r.object_id;
        if (!id) return;

        // Element ueber id (Radio, Checkbox, Multitag-Button, Input, Textarea)
        let el = null;
        try { el = scope.querySelector('[id="' + id + '"]'); } catch (e) { el = null; }

        if (el) {
            const tag = el.tagName;
            if (tag === "INPUT" && (el.type === "radio" || el.type === "checkbox")) {
                el.checked = true;
                el.setAttribute("checked", "checked");
            } else if (tag === "INPUT") {
                el.value = r.result || "";
                el.setAttribute("value", r.result || "");
            } else if (tag === "TEXTAREA") {
                el.value = r.result || "";
            } else if (tag === "BUTTON") {
                el.classList.add("active");
            }
            touched.push(el);
            return;
        }

        // Elemente ueber data-name (Likert, Reminder)
        let nodes = [];
        try { nodes = scope.querySelectorAll('[data-name="' + id + '"]'); } catch (e) { nodes = []; }
        nodes.forEach((btn) => {
            const isLikert = btn.closest(".segmented") && !btn.closest(".reminder-options");
            if (isLikert) {
                if (String(btn.value) === String(r.value)) {
                    btn.classList.add("button-active");
                    touched.push(btn);
                }
            } else if (btn.closest(".segmented")) {
                btn.classList.add("button-active");
                touched.push(btn);
            } else {
                btn.classList.add("active");
                touched.push(btn);
            }
        });
    });

    // Betroffene Bloecke sperren
    touched.forEach((el) => {
        const block = el.closest(".block");
        if (!block) return;
        block.classList.add("answered");
        block.querySelectorAll("input, textarea, button").forEach((f) => {
            f.disabled = true;
            f.setAttribute("disabled", "disabled");
            if (f.tagName === "TEXTAREA" || (f.tagName === "INPUT" && f.type === "text")) {
                f.readOnly = true;
            }
        });
    });

    return touched.length;
}
